import { Component } from "react";
import { Route, Routes } from "react-router";

import LoginPage from "./Login/LoginPage";
import LoginCallback from "./LoginCallback";
import Redirect from "nvent-web/components/Redirect";

export class Auth extends Component {
  render() {
    return (
      <Routes>
        <Route path="login" Component={LoginPage} />
        <Route path="login/callback" Component={LoginCallback} />
        <Route path="*" element={<Redirect to="/auth/login" />} />
      </Routes>
    );
  }
}

export default Auth;
